import React from 'react';
import {arrayObjSort} from "../../../shared/utils/sortArray";
import {dateFormatGGmmmYYYY, daysIt, padNumber} from "../../../shared/utils/dateUtils";
import PrintCalendarDataTr from "./PrintCalendarTr";


const PrintCalendarData = ({employees = [], hours = [], selectedRange}: {
    selectedRange: any,
    employees?: any[],
    hours: any[]
}) => {
    const hoursPrint = (employees || []).map(em => ({
        employee: em,
        hours: arrayObjSort(hours.filter(h => h.idEmployee === em.idDocument).map(h => ({
            date: h.date,
            day: h.day,
            month: h.month,
            list: h.list,
            dayLabel: daysIt[new Date(h.date).getDay()]
        })), 'date')
    }))

    const getNext7Days = (startDate: any) => {
        const dates = [];

        for (let i = 0; i < 7; i++) {
            const nextDate = new Date(startDate);
            nextDate.setDate(startDate.getDate() + i);
            dates.push(nextDate);
        }

        return dates;
    };
    const startDate = new Date(selectedRange.start)
    const endDate = new Date(selectedRange.end)
    const arrayDate = getNext7Days(startDate)

    return (
        <div>
            <h3>PIANIFICAZIONE TURNI LAVORO TEST STRAORDINARIO
                DAL {startDate ? dateFormatGGmmmYYYY(startDate) : '-'} - {endDate ? dateFormatGGmmmYYYY(endDate) : '-'}</h3>

            <table className={'table-print mt-2'}>
                <thead>
                <tr>
                    <th></th>
                    <th></th>
                    {arrayDate.map(d => <th>{daysIt[d.getDay()]} {padNumber(d.getDate())}</th>)}</tr>
                </thead>
                <tbody>
                {hoursPrint.map(em => <PrintCalendarDataTr employee={em} arrayDate={arrayDate}/>)}
                </tbody>
            </table>
        </div>
    );
};

export default PrintCalendarData;
